import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import VueFire from 'vuefire'
import VueClipboard from 'vue-clipboard2'

import { auth } from './firebase'
import App from './App'
import router from './router'
import { store } from './store'
require('./assets/css/materialdesignicons.min.css')

import UploadJobs from './components/UploadJobs.vue'
import AlertCmp from './components/Shared/Alert.vue'
import UpdateDialog from './components/Shared/UpdateDialog.vue'
import DisclaimerDialog from './components/Shared/DisclaimerDialog.vue'
import Testing from './components/Testing.vue'

Vue.use(VueClipboard)
Vue.use(VueFire)
Vue.use(Vuetify, {
  theme: {
    primary: '#4BBBBD',
    secondary: '#091C48',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})
Vue.component('Upload-Jobs', UploadJobs)
Vue.component('app-alert', AlertCmp)
Vue.component('update-dialog', UpdateDialog)
Vue.component('disclaimer-dialog', DisclaimerDialog)
Vue.component('testing', Testing)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  store,
  created () {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        this.$store.dispatch('fetchUserData')
        this.$store.dispatch('setCustomers')
        this.$store.dispatch('setVehicles')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js